export default "__VITE_ASSET__ea009890__"